// extracted by mini-css-extract-plugin
module.exports = {"F":"F_F__wzJdu"};